module.exports = __webpack_public_path__ + "static/media/bone.8fd81eaf.svg";